import moment from "moment-timezone";
import {isMobileOnly} from 'react-device-detect';
import Alert from 'react-s-alert';

// Production
export const backendEndpoint = 'https://api.bookmeey.com/bookme/v1/'
export const authEndpoint = 'https://api.bookmeey.com/'
export const baseEndpoint = 'https://api.bookmeey.com/'

// Local
// export const backendEndpoint = 'http://localhost:8000/bookme/v1/'
// export const authEndpoint = 'http://localhost:8000/'
// export const baseEndpoint = 'http://localhost:8000/'

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export function verifyPathname (targetPathname) {
    let pathname = window.location.pathname;
    let pathnameList = pathname.split("/");
    if (pathnameList.length > 2) {
        return pathnameList[1] === targetPathname;
    }
    return false;
}

// common helper function
export function beautifyLocalTimeFromTimestamp(timestamp){
    return moment(new Date(timestamp * 1000)).format('llll');
}

export function beautifyLocalDateFromTimestamp(timestamp){
    return moment(new Date(timestamp * 1000)).format('ll');
}

export function getCurrentTimezone() {
    // return Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment.tz.guess(); // using this since Android Webview can't use the above function
}

export function useMobile(){

    if ((window.innerHeight > window.innerWidth) && isMobileOnly){
        return true;
    }
    else {
        return false;
    }
}

export function alertErrors(err) {
    if (err.response.data.error.length > 0) {
        for (const index in err.response.data.error[0]) {
            Alert.error(index + ": " + err.response.data.error[0][index][0].message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/utility.js